import {combineReducers, configureStore} from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
//import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage'
import reportReducer from '../reducers/report/reportReducer'
import datasetReducer from '../reducers/dataset/datasetReducer'

import thunk from 'redux-thunk'
import breadcrumbReducer from '../reducers/breadcrumb'
import settings from '../../config/settings/index.jsx'

/* const encryptor = encryptTransform({
    secretKey: 'jhjvn',
    onError(error) {
      // Handle the error.
    }
  }); */
  

const rootReducer = combineReducers({
    reportDetails: reportReducer,
    dataset: datasetReducer,
    breadcrumb: breadcrumbReducer
})

const persistConfig = {
    key: "root",
    version: 1,
    storage,
    //transforms: [encryptor],
  };

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    devTools: settings ? settings?.IS_DEV_TOOLS_ENABLED : false,
    middleware: [thunk]
})

export const persistor = persistStore(store)

export default store